import RenderHTML, { MixedStyleDeclaration } from 'react-native-render-html';
import Show from '../../../Show/Show';
import { COLORS } from '../../../../config/designSystem/Colors';
import { Caption1Reg, Caption2Reg, H2, H3, ParagraphMRegularTextStyle } from '../../../../config/designSystem/typography';
import { FC } from 'react';
import { Feather } from '@expo/vector-icons';
import { Image, StyleSheet, useWindowDimensions } from 'react-native';
import { QuestionSessionBodyPresentationProps } from '../config';
import { SPACING } from '../../../../config/designSystem/Spacing';
import { View } from 'react-native-animatable';
import { getMetaValue } from '../../../Answer/utils';
import { observer } from 'mobx-react';
import { useStores } from '../../../../hooks/useStores';

const _PresentCounsellorBio: FC<QuestionSessionBodyPresentationProps> = ({
  margin,
  meta,
}) => {
  const { language } = useStores();
  const { width } = useWindowDimensions();
  const labels = language.translate?.MOBILE?.ASSISTANCE;
  const image = getMetaValue('picture', {meta});
  const title = getMetaValue('title', {meta});
  const gender = getMetaValue('gender', {meta});
  const genderLabel = gender ? labels?.WPO?.GENDER?.[gender.toLocaleUpperCase()] : undefined;
  const description = getMetaValue('description', {meta});
  return (
    <View style={[
      styles.mainView,
      {marginHorizontal: margin}
    ]}>

      <View style={styles.header}>
        <Show
          when={image}
          fallback={
            <View style={styles.avatar}>
              <Feather
                name="user"
                size={42}
                color={COLORS.content.accent}
                style={{alignSelf: 'center'}}
              />
            </View>
          }
        >
          <Image source={{uri: image}} style={styles.image} resizeMode='contain' />
        </Show>
        <View style={styles.headerText}>
          <H2>{title}</H2>
          <Caption1Reg>{labels?.WPO?.COUNSELLOR}</Caption1Reg>
        </View>
      </View>

      <View style={styles.content}>
        <View style={styles.about}>
          <H3>{labels?.PSYCHOLOGIST?.ABOUT}</H3>
          <Caption2Reg>{genderLabel || gender}</Caption2Reg>
        </View>
        <Show when={description} keyed>
          {html => (
            <RenderHTML
              source={{html: `<p>${html}</p>`}}
              baseStyle={ParagraphMRegularTextStyle({}) as MixedStyleDeclaration}
              contentWidth={width}
            />
          )}
        </Show>
      </View>
    </View>
  );
};
export const PresentCounsellorBio = observer(_PresentCounsellorBio);

const styles = StyleSheet.create({
  mainView: {
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACING['sp-16'],
    alignSelf: 'stretch',
  },
  headerText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACING['sp-8'],
    alignSelf: 'stretch',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: SPACING['sp-16'],
    alignSelf: 'stretch',
  },
  about: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: SPACING['sp-4'],
    alignSelf: 'stretch',
  },
  avatar: {
    width: SPACING['sp-64'],
    height: SPACING['sp-64'],
    backgroundColor: COLORS.surface.accent,
    justifyContent: 'center',
    borderRadius: 99,
  },
  image: {
    borderRadius: SPACING['sp-32'],
    height: 120,
    width: 120,
    justifyContent: 'center'
  },
});
